import { render } from "./ContactSurSiteList.vue?vue&type=template&id=54fba8c7&scoped=true&ts=true"
import script from "./ContactSurSiteList.vue?vue&type=script&lang=ts"
export * from "./ContactSurSiteList.vue?vue&type=script&lang=ts"

import "./ContactSurSiteList.vue?vue&type=style&index=0&id=54fba8c7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fba8c7"]])

export default __exports__